import { Label, clx } from '@medusajs/ui';

interface TagProps {
  text: string;
  className?: string;
}

const Tag = ({ text, className }: TagProps) => {
  return (
    <Label
      className={clx(
        'whitespace-nowrap rounded px-2 py-1 text-center font-bold',
        className
      )}
    >
      {text}
    </Label>
  );
};

export default Tag;
